module.exports = __webpack_public_path__ + "img/image (7).33e04e75.png";